import { styled } from '@mui/material';

export const FlexContainer = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  alignContent: 'flex-start',
  gap: theme.spacing(2),
}));

export default FlexContainer;
